var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinNumberPink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70968 9.41935H1.35484V5.35484H0V4H2.70968V9.41935ZM8.58064 8.06452H5.87097V7.16129H7.67742C8.17419 7.16129 8.58064 6.75484 8.58064 6.25806V4.90323C8.58064 4.40645 8.17419 4 7.67742 4H4.51613V5.35484H7.22581V6.25806H5.41935C4.92258 6.25806 4.51613 6.66452 4.51613 7.16129V9.41935H8.58064V8.06452ZM14 8.51613V4.90323C14 4.40645 13.5935 4 13.0968 4H9.93548V5.35484H12.6452V6.25806H10.8387V7.16129H12.6452V8.06452H9.93548V9.41935H13.0968C13.5935 9.41935 14 9.0129 14 8.51613Z",
    fill: "#E7038E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinNumberPink);
export default __webpack_public_path__ + "static/media/pinNumberPink.968eca962cdbf5a496ca6f0fbc63a3ce.svg";
export { ForwardRef as ReactComponent };